import { render, staticRenderFns } from "./temporaryWorkFeedback.vue?vue&type=template&id=5f049144&"
import script from "./temporaryWorkFeedback.vue?vue&type=script&lang=js&"
export * from "./temporaryWorkFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports